export const VOICE_GENDER_OPTIONS = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Neutral', value: 'Neutral' },
];
